import type { CompiledTextElement } from "../types/template";
import { hasPerCharMetrics } from "./fontWidthData";

/**
 * Validates that a text element uses a font family with per-character width
 * metrics (Font 0 or fixed-width A–H). Throws if the font is unrecognised.
 */
export function assertKnownFont(element: CompiledTextElement): void {
  if (!hasPerCharMetrics(element.font.family)) {
    throw new Error(
      `Font family "${element.font.family}" has no per-character width metrics. Only Font 0 and fixed-width fonts (A–H) are supported.`,
    );
  }
}
